import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import "./cancelReservationModal.scss";
import { HOSTNAME, isExternalUrl } from "@src/utils";

const CancelReservationModal = ({ isShow, onClose }) => {
  const navigate = useNavigate();
  const params = useParams();
  const partnerUuid = params.uuid;
  return (
    <BottomFixedModal
      className="cancel-reservation-modal"
      isShow={isShow}
      title="😥"
      isTransition={true}
      hideModal={() => onClose(false)}
    >
      <h2 className="bold">
        불편사항이 있었나요? <br />
        1:1 상담을 진행해보세요.
      </h2>
      <p>
        종료 버튼을 누르면 계약 진행이 중단됩니다. 인기 웨딩홀의 일정은 실시간으로 마감될 수
        있습니다.
        {/* 종료를 누르시면 더 이상 계약이 진행되지 않습니다.<br/>
                취소 시 인기많은 웨딩홀은 계약이 마감될 수 있습니다. */}
      </p>
      <div className="btn-wrap btn-wrap-columns-1-1 btn-wrap-no-padding-x">
        <button
          className="btn btn-giant btn-red0 btn-full"
          onClick={() => {
            window.location.href = isExternalUrl(`${HOSTNAME}/mypage/chat`); // "h2mwbell://chat";
          }}
        >
          1:1상담
        </button>
        <button
          className="btn btn-giant btn-red500 btn-full"
          onClick={() =>
            navigate(`/weddinghall/${partnerUuid}?tabId=2&hidetop=true`, {
              replace: true,
              state: { toast: "계약 진행이 종료되었습니다." },
            })
          }
        >
          종료
        </button>
      </div>
    </BottomFixedModal>
  );
};

export default CancelReservationModal;
